import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';

import usePromoMeta from '../hooks/usePromoMeta';

import PromoByToggle, { type PromoByToggleSearch } from './PromoByToggle';
import PromoByToggleResults from './PromoByToggleResults';

type Props =
  | { codeName?: never; voucherName?: never }
  | { codeName: string; voucherName?: never }
  | { codeName?: never; voucherName: string };

export default function PromoByToggleTester({ codeName, voucherName }: Props) {
  const { promoMeta } = usePromoMeta();
  const [search, setSearch] = useState<PromoByToggleSearch>();
  const [isExpanded, setIsExpanded] = useState(false);
  const lockedName = codeName ?? voucherName;
  const lockedModeProps =
    lockedName !== undefined
      ? { isActive: isExpanded, includeRelatedFeaturesSet: true, displayModeSet: 'refined' as const }
      : {};
  const promoByToggle =
    codeName !== undefined ? (
      <PromoByToggle promoMeta={promoMeta} codeName={codeName} onSearchChange={setSearch} {...lockedModeProps} />
    ) : voucherName !== undefined ? (
      <PromoByToggle promoMeta={promoMeta} voucherName={voucherName} onSearchChange={setSearch} {...lockedModeProps} />
    ) : (
      <PromoByToggle promoMeta={promoMeta} onSearchChange={setSearch} />
    );

  const contents = (
    <>
      {promoByToggle}
      <PromoByToggleResults search={search} promoMeta={promoMeta} />
    </>
  );

  if (lockedName !== undefined) {
    return (
      <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
        <Accordion expanded={isExpanded} onChange={(_, nextExpanded) => setIsExpanded(nextExpanded)} disableGutters>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
              <Typography variant="subtitle2">Toggle configuration</Typography>
              <Typography variant="body2" color="text.secondary">
                {lockedName}
              </Typography>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>{contents}</AccordionDetails>
        </Accordion>
      </Box>
    );
  }

  return contents;
}
